import {Component, OnInit, HostListener, Input} from '@angular/core';
import {Constants} from '../shared/constants';
import {WindowRefService} from '../shared/window-ref-service.service';

@Component({
  selector: 'app-masthead',
  templateUrl: './masthead.component.html',
  styleUrls: ['./masthead.component.scss']
})
export class MastheadComponent implements OnInit {

  constructor(private windowRef: WindowRefService) {
  }

  windowHeight: number;

  @Input() scrollToArgs;

  get _s() { // Alias
    return this.scrollToArgs;
  }

  ngOnInit() {
    // window:load happens too late, the masthead is shown with smaller height first if
    // we don't set its height here in early state.
    this.updateWindowHeight(null);
  }

  @HostListener('window:load', ['$event'])
  @HostListener('window:resize', ['$event'])
  updateWindowHeight(event) {
    if (!this.windowRef.nativeWindow) {
      // If there is no Window, maybe we could extract from the actual event what the root object is
      // event.path[0]
      // event.currentTarget
      return;
    }
    this.windowHeight = this.windowRef.nativeWindow.innerHeight;
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/masthead/masthead.component.ts